// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1xvEE","rootCenter":"LoadMoreObserver_rootCenter__1r0gT","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2kiDS"};